import React from "react";
import { Link } from "react-router-dom";
import { programmes } from "../data/programmes";
import "./WhatWeDo.css";

const pillars = [
  {
    id: "nutrition",
    title: "Nutrition & Health",
    programmes: [
      "Feeding Programme",
      "Nutrition & Health Education",
      "Home-Based Care",
    ],
  },
  {
    id: "education",
    title: "Education",
    programmes: [
      "Literacy & Saturday School",
      "Early Childhood Development",
      "Orphans & Vulnerable Children",
    ],
  },
  {
    id: "skills",
    title: "Skills Development & Training",
    programmes: [
      "Short Courses",
      "Women's Empowerment Training",
      "Youth Empowerment",
    ],
  },
  {
    id: "climate",
    title: "Climate Change & the Environment",
    programmes: ["Sustainable Farming", "Climate Change Education"],
  },
];

const categoryColors = {
  nutrition: "#1a4a2e",
  education: "#2d6b45",
  empowerment: "#8b1a1a",
  environment: "#2e5902",
};

const pillarLabels = {
  nutrition: "Nutrition & Health",
  education: "Education",
  empowerment: "Skills Development",
  environment: "Climate & Environment",
};

export default function WhatWeDo() {
  return (
    <main>
      <section className="page-hero" aria-label="What We Do page hero">
        <div
          className="page-hero-bg"
          style={{
            backgroundImage: "url('/images/gallery/smiling-child-02.jpg')",
          }}
        />
        <div className="container page-hero-content">
          <span className="eyebrow" style={{ color: "var(--amber-light)" }}>
            Our Programmes
          </span>
          <h1>Four Pillars of Change</h1>
          <p>
            Every programme targets a specific, documented need. Together they
            address the full cycle of vulnerability — from early childhood
            nutrition to climate resilience.
          </p>
        </div>
      </section>

      {/* FOUR PILLARS OVERVIEW */}
      <section
        className="section pillars-overview-section"
        aria-label="Programme pillars"
      >
        <div className="container">
          <div className="section-title">
            <span className="eyebrow">How We Work</span>
            <h2>Our Four Areas of Focus</h2>
            <div className="divider divider-center" />
            <p>
              All our work falls under four interconnected pillars, each
              addressing a critical dimension of poverty and vulnerability
              across Southern Africa.
            </p>
          </div>
          <div className="pillar-overview-grid">
            {pillars.map((p) => (
              <div className="pillar-overview-card" key={p.id}>
                <h3>{p.title}</h3>
                <ul>
                  {p.programmes.map((name) => (
                    <li key={name}>{name}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROGRAMME LIST */}
      <section className="section" aria-label="All programmes">
        <div className="container">
          <div className="programmes-list">
            {programmes.map((prog, i) => (
              <article
                className={`programme-row${i % 2 === 1 ? " reverse" : ""}`}
                key={prog.id}
                aria-labelledby={`prog-${prog.id}`}
              >
                <div className="programme-row-image">
                  <img src={prog.image} alt={prog.name} loading="lazy" />
                  <span
                    className="prog-category-tag"
                    style={{ background: categoryColors[prog.category] }}
                  >
                    {pillarLabels[prog.category]}
                  </span>
                </div>
                <div className="programme-row-content">
                  <span className="eyebrow">{prog.pillar}</span>
                  <h2 id={`prog-${prog.id}`}>{prog.name}</h2>
                  <div className="divider" />
                  <p>{prog.shortDescription}</p>
                  <p className="prog-impact-line">
                    <strong>Impact:</strong> {prog.impactStatement}
                  </p>
                  <div className="donation-nudge">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="var(--amber)"
                      aria-hidden="true"
                    >
                      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                    </svg>
                    <p>{prog.donationNudge}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-band" aria-label="Support CTA">
        <div className="container cta-band-inner">
          <div>
            <h2>Every Programme Needs Your Support</h2>
            <p>Choose a cause and make a direct impact today.</p>
          </div>
          <div className="cta-band-actions">
            <Link to="/donate" className="btn btn-primary btn-lg">
              Donate Now
            </Link>
            <Link to="/get-involved" className="btn btn-secondary">
              Volunteer
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
